// Closing Entries Vuex

import state from './closingEntryStates.js'
import * as getters from './closingEntryGetters.js'
import * as mutations from './closingEntryMutations.js'
import * as actions from './closingEntryActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
